import useLayoutValuesRefresh from './useLayoutValuesRefresh';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Widgets from '../../components/3modules/Widgets/Widgets';
import {
  getDashboardErrorMessage,
  useGetDashboardWidgetsQuery
} from './dashboardApi';
import { canViewDashboardData } from './dashboardPermissions';
import { sortCalculatedDashboardWidgets } from './dashboardWidgetViewModel';

const DashboardWidgets = ({
  className,
  clickable = true,
  compact = false,
  header = false,
  locationId
}) => {
  const canView = canViewDashboardData();
  const skip = !locationId || !canView;
  const widgetsQuery = useGetDashboardWidgetsQuery(locationId, {
    skip,
    refetchOnMountOrArgChange: true
  });
  useLayoutValuesRefresh(locationId, () => {
    if (!skip) widgetsQuery.refetch();
  });

  if (skip) return null;
  if (widgetsQuery.isLoading) {
    return (
      <Box
        alignItems="center"
        display="flex"
        gap={1}
        role="status"
        sx={{ minHeight: compact ? 70 : 60 }}
      >
        <CircularProgress aria-label="Loading dashboard widgets" size={18} />
        {header && (
          <Typography color="text.secondary" fontSize={12}>
            Loading latest performance…
          </Typography>
        )}
      </Box>
    );
  }

  const error = widgetsQuery.error;
  if (error) {
    return (
      <Alert severity="warning" sx={{ py: 0.5 }}>
        {getDashboardErrorMessage(
          error,
          'Latest dashboard performance could not be loaded.'
        )}
      </Alert>
    );
  }

  const widgets = sortCalculatedDashboardWidgets(
    widgetsQuery.data?.widgets ?? []
  );

  return (
    <Widgets
      className={className}
      clickable={clickable}
      compact={compact}
      header={header}
      locationId={locationId}
      widgets={widgets}
    />
  );
};

export default DashboardWidgets;
